import { initialQuery } from '../../query-param-adapter/model/constants/initial-query.tsx';
import type { Query } from '../../query-param-adapter/model/index.tsx';
import { SET_QUERY, PATCH_QUERY, type Action } from './actions.tsx';

export const initialState: Query = initialQuery;

const query = (state: Query = initialState, action: Action): Query => {
	switch (action.type) {
		case SET_QUERY:
			return action.payload;
		case PATCH_QUERY:
			return {
				...state,
				...action.payload,
			};
		default: {
			const _exhaustiveCheck: never = action;
			return state;
		}
	}
};

export default query;
